import { render, staticRenderFns } from "./LocationListFilter.vue?vue&type=template&id=636486c1"
import script from "./LocationListFilter.vue?vue&type=script&lang=ts"
export * from "./LocationListFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports